export enum RarityType {
    Unknown,
    Common,
    Rare,
    Legendary
}